
import Vue from "vue";

export default Vue.extend({
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      title: this.project.title,
      languages: this.project.languages,
      description: this.project.description,
      technologies: this.project.technologies,
      image: this.project.image,
      github: this.project.github,
      live: this.project.live ? this.project.live : null,
    };
  },
  methods: {
    langColor(language: string) {
      if (language === "Typescript") {
        return "#2F74C0";
      } else if (language === "Javascript") {
        return "#EFD81D";
      } else if (language === "C#") {
        return "#9A6CD1";
      } else if (language === "Shaders" || language === "Compute Shaders") {
        return "#5080A9";
      } else {
        return "#868E96";
      }
    },
    techColor(technology: string) {
      if (
        technology === "Vue" ||
        technology === "Nuxt" ||
        technology === "Vuex"
      ) {
        return "#40B681";
      } else if (technology === "React" || technology === "React Native") {
        return "#5ED3F3";
      } else if (technology === "Tailwind") {
        return "#15B3C0";
      } else if (technology === "Unity") {
        return "#FFFFFF";
      } else if (technology === "MagicaVoxel") {
        return "#45239B";
      } else {
        return "#868E96";
      }
    },
  },
});
